import { create } from "zustand";
import { persist } from "zustand/middleware";

/**
 * UI shell state — currently just sidebar collapsed/expanded. Persisted so
 * the user's choice survives reload.
 */
export const useUiStore = create(
  persist(
    (set) => ({
      sidebarCollapsed: false,
      toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
    }),
    {
      name: "sher-e-punjab-admin-ui",
      partialize: (s) => ({ sidebarCollapsed: s.sidebarCollapsed }),
    }
  )
);
